// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"167":"detail","177":"home"}[chunkId] || chunkId) + "." + {"167":"1b93a3a6","177":"7960ed00","485":"139981a9","714":"18cb2fa7"}[chunkId] + ".js";
};